export const INVITE_NEW_USER_REQUEST = "INVITE_NEW_USER_REQUEST";
export const INVITE_NEW_USER_RECEIVE = "INVITE_NEW_USER_RECEIVE";
export const INVITE_NEW_USER_FAILURE = "INVITE_NEW_USER_FAILURE";
export const RESET_INVITE_NEW_USER = "RESET_INVITE_NEW_USER";
